import { render, staticRenderFns } from "./rebate.vue?vue&type=template&id=2a144fe0&scoped=true&"
import script from "./rebate.vue?vue&type=script&lang=ts&"
export * from "./rebate.vue?vue&type=script&lang=ts&"
import style0 from "./rebate.vue?vue&type=style&index=0&id=2a144fe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a144fe0",
  null
  
)

export default component.exports